
import * as React from "react"
import { Employee } from "../../../types/types";
import SimpleFormat from "../../../utils/SimpleFormat";

type Props = {
  employee: Employee
  className: string
}

export default (props: Props) : JSX.Element => (
  <div className={props.className}>
    <div className="employee">
      <figure className="employee__visual">
        <img
          src={props.employee.image}
          className="employee__image"
          alt={props.employee.name}
        />
      </figure>
      <h3 className="employee__title">
        {props.employee.name}
      </h3>
      <div className="employee__bio">
        <SimpleFormat text={props.employee.description} />
      </div>
    </div>
  </div>
)
